import { authenticatedFetch } from "./utils";
import type { ApiResponse } from "../../types/api";
import API_CONSTANTS from "../constants/api";

export type Address = {
  id?: number;
  label?: string;
  address1: string;
  zip: string;
  city: string;
  state: string;
  country: string;
  latitude?: number;
  longitude?: number;
  address2?: string;
  note?: string;
  formattedAddress?: string;
};

export type SearchAddressPrediction = {
  street_number: string;
  route: string;
  city: string;
  state: string;
  zip: string;
  country: string;
  latitude: number;
  longitude: number;
  address1: string;
  formatted_address: string;
};

export type SearchAddressResponse = ApiResponse & {
  addresses: SearchAddressPrediction[];
};

export type PersistedAddress = Address & { is_default?: boolean, id: number };
export type AddressResponse = ApiResponse & { address: Address & { id: number } };

export const createAddress = async (address: Address): Promise<AddressResponse> => {
  const url = `${API_CONSTANTS.authApiBaseUrl}/me/addresses`;
  const result = await authenticatedFetch(url, {
    method: "POST",
    body: JSON.stringify(address)
  });
  return (await result.json()) as AddressResponse;
};

export const updateAddress = async (address: Address): Promise<AddressResponse> => {
  const url = `${API_CONSTANTS.authApiBaseUrl}/me/addresses/${address.id}`;
  const result = await authenticatedFetch(url, {
    method: "PUT",
    body: JSON.stringify(address)
  });
  return (await result.json()) as AddressResponse;
};

export const setAddressAsDefault = async (id: number): Promise<ApiResponse> => {
  const url = `${API_CONSTANTS.authApiBaseUrl}/me/addresses/${id}/set-default`;
  const result = await authenticatedFetch(url, { method: "POST" });
  return (await result.json()) as ApiResponse;
};

export const searchAddress = async (query: string, countryCodes: string = ""): Promise<SearchAddressResponse> => {
  const url = `${API_CONSTANTS.serverlessFunctionsBaseUrl}/address/search?query` +
    `=${encodeURIComponent(query)}&countryCodes=${encodeURIComponent(countryCodes)}`;

  const result = await authenticatedFetch(url, {
    method: "GET"
  });

  return (await result.json()) as SearchAddressResponse;
};
